/**
 * Convierte un archivo de imagen (JPG, PNG, etc.) a WebP.
 * @param {File} file - El archivo original subido por el usuario.
 * @param {number} quality - Calidad de 0 a 1 (0.8 es un excelente balance).
 * @returns {Promise<File>} - Retorna el nuevo archivo en formato WebP.
 */
export const convertToWebp = (file, quality = 0.8) => {
    return new Promise((resolve, reject) => {
        // Si el usuario ya subió un WebP, no perdemos tiempo y lo devolvemos tal cual
        if (file.type === 'image/webp') {
            resolve(file);
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            
            img.onload = () => {
                // Creamos un lienzo invisible del mismo tamaño que la foto original
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                // Exportamos el lienzo como WebP
                canvas.toBlob(
                    (blob) => {
                        if (!blob) {
                            reject(new Error('Error al convertir la imagen.'));
                            return;
                        }
                        
                        // Le cambiamos la extensión al nombre original (ej: "foto.jpg" -> "foto.webp")
                        const newFileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
                        
                        // Creamos el nuevo archivo listo para enviar
                        const webpFile = new File([blob], newFileName, {
                            type: "image/webp",
                            lastModified: Date.now(),
                        });
                        
                        resolve(webpFile);
                    },
                    'image/webp',
                    quality // 0.8 comprime el peso drásticamente manteniendo la foto nítida
                );
            };
            img.onerror = (error) => reject(error);
        };
        reader.onerror = (error) => reject(error);
    });
};